import { render } from "./LinkedObject.vue?vue&type=template&id=e8260652&scoped=true"
import script from "./LinkedObject.vue?vue&type=script&lang=js"
export * from "./LinkedObject.vue?vue&type=script&lang=js"

import "./LinkedObject.vue?vue&type=style&index=0&id=e8260652&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8260652"]])

export default __exports__